import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import DetailView from '../../../dpe-usco/components/Details/DetailView'
import DocUploader from '../../DocUploader/DocUploader'
import leftArrow from '../../../dpe-usco/asset/icons/left_arrow.svg'
import '../../../scss/config/_variables.scss'
import { getCompany, getHighestRole, getInventoryCodes, getGrowersNamesFromProdPlanUnplanned, 
  postUnplannedTransfer, getProductionPlan, getSalesYear, getGrowersNamesFromSearchUnplanned } from '../../../services/apiHelper'
import { yearsOptionFactory } from '../../../services/utils'
import Select from '../../../dpe-usco/components/Select/Select'
import error_outline from '../../../assets/icons/error_outline.svg'
import arrow_forward from '../../../assets/icons/arrow_forward.svg'
import close from '../../../assets/icons/close.svg'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import greenCheck from '../../../assets/icons/circle_check_green.svg'
import SearchBox from '../../../components/subComponents/SearchBox'
import searchIcon from '../../../assets/icons/searchWhite.svg'

import './UploadScaleTicketDetailView.scss'

const CancelModal = ({ showCancelModal, setCancelModal }) => {
  let history = useHistory()
  return (
    <Modal
      autoHeight
      show={showCancelModal}
      handleClose={() => setCancelModal(false)}
    >
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb'>
          <div className='df ml15 mt15 mb15'>
            <div className='fw600 ml10'>
              Leave scale ticket upload?
            </div>
          </div>
        </div>
        <div className='p25 h80 df aic jcfs'>
          Unsaved Scale tickets will not be saved on leaving.
        </div>
        <div className='bt1-s-lightgray df aic jcfe'>
          <div className='mt8 mb8 mr8'>
            <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={() => setCancelModal(false)} />
            <Button customClassName='miw70' type='error' text='Leave upload' onClick={() => history.goBack()} />
          </div>
        </div>
      </div>
    </Modal>
  )
}

const UnplannedModal = ({ showUnplannedModal, setUnplannedModal, defaultYear, yearsOptions, parentSetTableData, setPageRefresh, productionPlanUrl }) => {
  const [selectedCode, setSelectedCode] = useState('')
  const [selectedGrower, setSelectedGrower] = useState('')
  const [selectedInventoryCodeData, setSelectedInventoryCodeData] = useState({})
  const [selectedGrowerData, setSelectedGrowerData] = useState({})
  const [inventoryCodes, setInventoryCodes] = useState([])
  const [growerContracts, setGrowerContracts] = useState([])
  const [inventoryLoader, setInventoryLoader] = useState('')
  const [growerLoader, setGrowerLoader] = useState('')
  const [defaultSelectedYear, setDefaultSelectedYear] = useState(defaultYear)
  const [status, setStatus] = useState('INIT')
  const [selectedType, setSelectedType] = useState('Contract')
  const [searchTerm, setSearchTerm] = useState('')
  const [contractNotLoad, setContractNotLoad] = useState('')
  const [noContractSearch, setNoContractSearch] = useState(false)
  const [wrongContactId, setWrongContactId] = useState(false)
  const [searchCategoryVal, setSearchCategoryVal] = useState(false)
  const [disableSearch, setDisableSearch] = useState(false)
  const [statusMessage, setStatusMessage] = useState([])

  const showGrowerContracts = async (code, inventoryData) => {
    setContractNotLoad(false)
    setDisableSearch(false)
    setSearchTerm('')
    setNoContractSearch(false)
    setWrongContactId(false)
    setSearchCategoryVal('')
    setSelectedInventoryCodeData(inventoryData)
    setSelectedCode(code)
    setGrowerLoader('LOADING')
    try{
      const res = await getGrowersNamesFromProdPlanUnplanned(inventoryData.production_plan_id)
      if(res?.length){
        setGrowerLoader('')
        res.sort(function(a, b) {
          const fName = a?.grower_name
          const sName = b?.grower_name
          var textA = fName.toUpperCase()
          var textB = sName.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
        setGrowerContracts(formatContracts(res,inventoryData))
      } else {
        setGrowerLoader('')
        setGrowerContracts([])
        setGrowerContracts([{ type: 'ProductionPlan', c: inventoryData.inventory_code }])
      }
    } catch {
      setContractNotLoad(true)
      setDisableSearch(false)
      setGrowerLoader('')
      setGrowerContracts([])
      setSelectedInventoryCodeData(inventoryData)
      setGrowerContracts([{ type: 'ProductionPlan', c: inventoryData.inventory_code }])
    }
  }
  const formatContracts = (contracts,inventoryData) => {
    const contractArray = []
    contracts.forEach(c => {
      contractArray.push({ type: 'contract', c: c })
    })
    contractArray.push({ type: 'production_plan', c: inventoryData.inventory_code })
    return contractArray
  }
  const saveContract = (index, growerData, type = 'Contract') => {
    setSelectedGrowerData(growerData)
    setSelectedGrower(index)
    setSelectedType(type)
  }

  useEffect(() => {
    setInventoryLoader('LOADING')
    getInventoryCodes(defaultSelectedYear).then(res => {
      setGrowerLoader('')
      setGrowerContracts([])
      const filterRes = res.inventory_codes.filter(x => x.production_plan_id !== productionPlanUrl)
      if (filterRes?.length) {
        filterRes.sort(function(a, b) {
          const fName = a?.company_name
          const sName = b?.company_name
          var textA = fName?.toUpperCase()
          var textB = sName?.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
        setInventoryCodes(filterRes)
        setInventoryLoader('')
      } else {
        setInventoryLoader('EMPTY')
      }
    })
  }, [defaultSelectedYear, productionPlanUrl])

  useEffect(() => {
    setNoContractSearch(false)
    setWrongContactId(false)
    setSearchCategoryVal('')
  }, [searchTerm,defaultSelectedYear,selectedInventoryCodeData])

  const handleSearch = () =>{
    let searchCategory = 'grower_name'
    let searchFlag = true
    if(searchTerm?.length >= 3){
      setGrowerLoader('LOADING')
      if(!isNaN(searchTerm.substring(0, 2)) && searchTerm.length === 16){
        const searchString = searchTerm.substring(0, 2)
        const searchYearString = defaultSelectedYear.toString().substring(2,4)
        if( searchString !== searchYearString) {
          searchFlag = false
          setWrongContactId(true)
          setGrowerLoader('')
          setGrowerContracts([])
          setGrowerContracts([{ type: 'ProductionPlan', c: selectedInventoryCodeData.inventory_code }])
        } 
        searchCategory = 'new_contract_id'
      }
      if(searchFlag === true) {
        setDisableSearch(true)
        getGrowersNamesFromSearchUnplanned(searchTerm, searchCategory, defaultSelectedYear).then(res => {
          setDisableSearch(false)
          if(res.data.contracts?.length && searchFlag === true){
            setGrowerLoader('')
            res.data.contracts.sort(function(a, b) {
              const fName = a?.grower_name
              const sName = b?.grower_name
              var textA = fName.toUpperCase()
              var textB = sName.toUpperCase()
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
            })
            setGrowerContracts(formatContracts(res.data.contracts,selectedInventoryCodeData))
          } else {
            setGrowerLoader('')
            setGrowerContracts([])
            setGrowerContracts([{ type: 'ProductionPlan', c: selectedInventoryCodeData.inventory_code }])
            setNoContractSearch(true)
            setSearchCategoryVal(searchCategory)
          }
        })
      }
    }
  }

  const filterHandler = year => {
    setSelectedCode('')
    setSelectedGrower('')
    setGrowerContracts([])
    setDefaultSelectedYear(year)
    setInventoryLoader('LOADING')
    setContractNotLoad(false)
    setDisableSearch(false)
    setSearchTerm('')
    getInventoryCodes(year).then(res => {
      const filterRes = res.inventory_codes.filter(x => x.production_plan_id !== productionPlanUrl)
      if (filterRes?.length) {
        setInventoryCodes(filterRes)
        setInventoryLoader('')
      } else {
        setInventoryLoader('EMPTY')
      }
    })
  }


  const massageForPost = (arr,selectedGrowerData,selectedInventoryCodeData, productionPlanUrl) => {
    let returnArr = arr.map(ticket => {
      return {
        bill_of_landing_number: ticket.BOL?.toString(),
        damage: ticket.DMG?.toString(),
        foreign_material: ticket.FM?.toString(),
        gross_lbs: ticket['Gross Weight']?.toString(),
        gross_quantity: ticket['Gross Qty']?.toString(),
        grower_name: selectedGrowerData.new_contract_id?selectedGrowerData.grower_name:selectedInventoryCodeData.company_name,
        moisture: ticket.MST?.toString(),
        net_lbs: ticket['Net Weight']?.toString(),
        net_quantity: ticket['Net Qty']?.toString(),
        rapid_visco_analyzer: ticket.RVA?.toString(),
        scale_ticket_number: ticket['Ticket Number'] && ticket['Ticket Number'].scale_ticket_id?.toString(),
        scale_ticket_date: new Date(ticket.Date),
        tar_lbs: ticket.Tare?.toString(),
        test_weight: ticket['Test Weight']?.toString(),
        external_reference_id: selectedGrowerData.contract_id?selectedGrowerData.contract_id:null,
        production_plan_id: productionPlanUrl,
        original_production_plan_inventory_code: selectedInventoryCodeData.inventory_code,
        original_production_plan_id: selectedInventoryCodeData.production_plan_id,
        original_contract_id: selectedGrowerData.contract_id?selectedGrowerData.contract_id:null,
        original_grower_name: selectedGrowerData.grower_name?selectedGrowerData.grower_name:null,
        original_new_contract_id: selectedGrowerData.new_contract_id?selectedGrowerData.new_contract_id:null,
        original_selected_type: selectedType,
        ...((ticket.notes?.toString() || ticket.Notes?.toString()) && { notes: ticket.notes?.toString()? ticket.notes?.toString() : ticket.Notes?.toString() ? ticket.Notes?.toString() : null })
      }
    })
    return {
      scale_tickets: returnArr
    }
  }

  const saveHandler = async () => {
    setStatus('LOADING')
    setStatusMessage([])
    let response = await postUnplannedTransfer(massageForPost(parentSetTableData,selectedGrowerData, selectedInventoryCodeData, productionPlanUrl))
    if (response.status === 200) {
      setStatus('SUCCESS')
    } else {
      setStatus('ERROR')
      setStatusMessage(response.data.errors)
    }
  }

  const onUnplannedModalClose = () => {
    setSelectedCode('')
    setSelectedGrower('')
    setGrowerContracts([])
    setStatus('INIT')
    setUnplannedModal(false)
    setPageRefresh(true)
  }

  const renderContent = status => {
    let content = ''
    switch (status) {
      case 'ERROR': {
        content = <div>
          {statusMessage?.length > 0 && statusMessage[0]?.key_path === 'scale_ticket_duplication' ?
            <>
              <div className='bb1-s-lightgray df jcsb'>
                <div className='df ml15 mt15 mb15'>
                  <img src={error_outline} alt='error icon' />
                  <div className='ml10'>
                    Duplicate scale ticket{statusMessage?.length > 1 && 's' } found which already exists
                  </div>
                </div>
                <img className='mr15 curp' onClick={onUnplannedModalClose} src={close}
                  alt='close icon'>
                </img>
              </div>
              <div className='pl20 pb40'>
                <p className="fw600 mb10 tal pl0">Duplicate record{statusMessage?.length > 1 && 's' }:</p>
                {statusMessage?.map((data, index) =>  
                  <div key={index}>{data.message}</div>
                )} 
              </div>
            </> : 
            <>
              <div className='bb1-s-lightgray df jcsb'>
                <div className='df ml15 mt15 mb15'>
                  <img src={error_outline} alt='error icon' />
                  <div className='ml10'>
                     Error uploading scale ticket
                  </div>
                </div>
                <img className='mr15 curp' onClick={onUnplannedModalClose} src={close}
                  alt='close icon'>
                </img>
              </div>
              <div className='pl20 pb40'>
                {statusMessage?.map((data, index) =>  
                  <p className='tal'  key={index}>{data.message}</p>
                )} 
              </div>
            </>
          }
        </div>
        break
      }
      case 'SUCCESS': {
        content = (<div className='df jcc p20'>
          <img src={greenCheck} alt='check mark'></img>
          <div className='ml10'>Scale tickets successfully saved.</div>
        </div>)
        break
      }
      case 'LOADING':
        content = <TableStatus status='LOADING'></TableStatus>
        break
      default:
        break
    }
    return content
  }

  return (
    <div className="modalContainer" style={{ display: showUnplannedModal ? 'block' : 'none' }}>
      <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
        <div className='w120% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          {renderContent(status)}
          {status !== 'INIT' && 
            <div className='bt1-s-lightgray df aic jcfe'>
              <div className='mt8 mb8 mr8'>
                <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={onUnplannedModalClose} />
              </div>
            </div>}
          {status === 'INIT' &&
              <div>
                <div className='bb1-s-lightgray df jcsb'>
                  <div className='df ml15 mt15 mb15'>
                    <img src={error_outline} alt='error icon' />
                    <div className='fw600 ml10'>
                      Unplanned transfer
                    </div>
                  </div>
                  <img className='mr15 curp' onClick={onUnplannedModalClose} src={close}
                    alt='close icon'>
                  </img>
                </div>
                <div className="w100">
                  <div className='ml15 mt15 mb15'>
                    <Select
                      handleSelection={year => {
                        filterHandler(year.value)
                      }}
                      defaultValue={defaultSelectedYear}
                      options={yearsOptions}
                    />
                  </div>
                </div>
                <div className='df fxdr fxww ml15 mt15 mb15 mr15'>
                  <div className="w45%">
                    <p className="m0 tal">Select original destination code</p>
                    <div className={`df fxdrc flx1 bd1-s-lightgray h250 oys fz15 ${inventoryLoader === 'LOADING' ? 'jcc' : ''}`}>
                      {
                        inventoryLoader === 'LOADING' ?
                          <div className='w100% h100 df jcc aic'>
                            <div data-testid='tableStatusLoader' className='loader' />
                          </div> : inventoryLoader === 'EMPTY' ?
                            <div className='w100% h100 df jcc aic'>
                              <span data-testid='tableStatusPrompt'>No data</span>
                            </div> :
                            inventoryCodes.map((data, index) => {
                              return <div key={index} className='p10 m0 w100% tal curp' style={{ backgroundColor: selectedCode === index ? '#1a75ff' : '', color: selectedCode === index ? 'white' : '' }} onClick={() => showGrowerContracts(index, data)}>
                                <h4 className="m0" style={{ textTransform: 'capitalize' }}>{data.company_name}</h4>
                                <p className="m0 mt5 p0 tal">{data.inventory_code}</p>
                              </div>
                            })
                      }
                    </div>
                  </div>
                  <img className='mau ml24 mr24 h25' src={arrow_forward} alt='arrow pointing right' />
                  <div className="w45%">
                    <p className="m0 tal">Select grower contract</p>
                    <div className="uploadScaleSearch">
                      {
                        contractNotLoad === true ?
                          <>
                            <p className="m0 pt0 pb0 tal fz16">The contracts cannot load.</p>
                            <p className="m0 pt0 pb10 tal fz16">Please search by Grower Name or Contract ID.</p>
                            <div className="mb5">
                              <div className='df fxdrc flx3'>
                                <div className='df w100%'>
                                  <SearchBox
                                    searchTerm={searchTerm}
                                    setSearchTerm={setSearchTerm}
                                    placeholder='Search'
                                  />
                                  <button className={`${disableSearch? 'custom-button-disabled' : null} mb0 w60 bgc-green bdnone bdrs-4`} onClick={handleSearch} disabled={disableSearch}>
                                    <img src={searchIcon} alt='search icon'/>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </>
                          : null }
                    </div>
                    <div className={`df fxdrc flx1 bd1-s-lightgray h250 oys fz15 ${growerLoader === 'LOADING' ? 'jcc' : ''}`}>
                      {growerLoader === 'LOADING' ?
                        <div className='w100% h100 df jcc aic'>
                          <div data-testid='tableStatusLoader' className='loader' />
                        </div> : growerLoader === 'EMPTY' ?
                          <div className='w100% h100 df jcc aic'>
                            <span data-testid='tableStatusPrompt'>No data</span>
                          </div> : <>
                            { growerContracts.map((data, index) => {
                              return data.type==='contract' ? (<div key={index} className="p5 pl10 m0 curp" style={{ backgroundColor: selectedGrower === index ? '#1a75ff' : '', color: selectedGrower === index ? 'white' : '' }} onClick={() => saveContract(index, data.c, 'contract')}>
                                <h4 className="m0" style={{ textTransform: 'capitalize' }}>{data.c.grower_name}</h4>
                                <p className="m0 mt5 p0 tal">{data.c.new_contract_id}</p>
                              </div>)
                                :
                                (<div key={index} className="p5 pl10 m0 curp" style={{ backgroundColor: selectedGrower === index ? '#1a75ff' : '', color: selectedGrower === index ? 'white' : '' }} onClick={() => saveContract(index, data.c, 'production_plan')}>
                                  <h4 className="m0" style={{ textTransform: 'capitalize' }}>{data.c||'N/A'}</h4>
                                </div>)
                            }) }
                          </>
                      }
                    </div>
                  </div>
                </div>
                <div className='bt1-s-lightgray df aic jcsb'>
                  {noContractSearch? <div className='c-red ml15'>No {searchCategoryVal === 'grower_name'? 'Grower names' : 'Contract ID' } for this Production Plan match this search. Please try again.</div> : null }
                  {wrongContactId? <div className='c-red ml15'>Contract ID not found. Make sure the correct year is selected and try again.</div> : null }
                  <div></div>
                  <div className='mt8 mb8 mr8 df'>
                    <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={onUnplannedModalClose} />
                    <Button customClassName='mr8 miw75 pl1 pr1' text='Save' backgroundColor='#238661' textColor={'#FFFFFF'} disabled={(selectedGrower || selectedGrower === 0) ? false : true} onClick={saveHandler}></Button>
                  </div>
                </div>
              </div>}
        </div>
      </div>
    </div>
  )
}

export const UploadScaleTicketView = () => {
  const [hasUpload, setHasUpload] = useState(false)
  const [hasAllRequiredData, setHasAllRequiredData] = useState(false)
  const [checkGrowerModalVisibility, setCheckGrowerModalVisibility] = useState(false)
  const [showCancelModal, setCancelModal] = useState(false)
  const [showUnplannedModal, setUnplannedModal] = useState(false)
  const [pageRefresh, setPageRefresh] = useState(false)
  const [companyName, setcompanyName] = useState('')
  const { company_id } = useParams()
  const [defaultYear, setDefaultYear] = useState(new Date().getFullYear().toString())
  const [auth, setAuth] = useState(false)
  const [parentSetTableData, setParentSetTableData] = useState()
  const { production_plan_id } = useParams()

  useEffect(() => {
    getProductionPlan(production_plan_id)
      .then(res => {
        setDefaultYear(res.contract_year)
      })
  }, [production_plan_id])

  const [defaultContractYear, setDefaultContractYear] = useState(
    new Date().getFullYear().toString()
  )
  useEffect(() => {
    const init = async () => {
      await getSalesYear().then(sales_year => {
        setDefaultContractYear(sales_year.data.sales_year)
      })
    }
    if (production_plan_id) {
      init()
    }
  }, [production_plan_id])

  const MAX_YEARS = 0
  const MIN_YEARS = -4
  const yearsOptions = yearsOptionFactory(parseInt(defaultContractYear), MIN_YEARS, MAX_YEARS)

  useEffect(() => {
    getHighestRole().then(res => {
      if (res.permissions.includes('adjust-inventory')) {
        setAuth(true)
      } else {
        setAuth(false)
      }
    })
  }, [])

  useEffect(() => {
    getCompany(company_id).then(obj => {
      setcompanyName(obj?.company_name)
    })
    if (pageRefresh) {
      window.location.reload()
    }
  })

  const buttons = (
    <div className='df'>
      <div className='mr10'>
        <Button text='Cancel' clickHandler={() => setCancelModal(true)}></Button>
      </div>
      <div className='mr10'>
        <Button
          text='Unplanned Transfer'
          clickHandler={() => setUnplannedModal(true)}
          disabled={!hasUpload || !hasAllRequiredData}
        ></Button>
      </div>
      <div>
        <Button text='Save and Upload' backgroundColor={hasUpload ? '#238661' : '#8FC0AE'} textColor={'#FFFFFF'} disabled={!hasUpload || !hasAllRequiredData} clickHandler={() => { setCheckGrowerModalVisibility(true) }}></Button>
      </div>
    </div>
  )
  return (
    <>
      <CancelModal showCancelModal={showCancelModal} setCancelModal={setCancelModal} />
      {auth && <UnplannedModal
        showUnplannedModal={showUnplannedModal}
        setUnplannedModal={setUnplannedModal}
        defaultYear={defaultYear}
        yearsOptions={yearsOptions}
        parentSetTableData={parentSetTableData}
        setPageRefresh={setPageRefresh}
        productionPlanUrl={production_plan_id}
      />}
      <button
        className='df aic jcsb posf l20'
        style={{
          background: 'none',
          color: 'inherit',
          border: 'none',
          padding: 0,
          font: 'inherit',
          cursor: 'pointer',
          outline: 'inherit'
        }}
        onClick={() => setCancelModal(true)}>
        <img src={leftArrow} alt='return arrow' className='curp mr10' />
        <span className='fz17 c-neutral-500 fs'>Back</span>
      </button>

      <DetailView button={buttons} title={companyName} disableBack={true}>
        <>
          <DocUploader setHasUpload={setHasUpload} setHasAllRequiredData={setHasAllRequiredData} checkGrowerModalVisibility={checkGrowerModalVisibility} toggleCheckGrowerModalVisibility={setCheckGrowerModalVisibility} setPageRefresh={setPageRefresh} parentSetTableData={setParentSetTableData} />
        </>
      </DetailView>
    </>
  )
}

export default UploadScaleTicketView